import styles from "./PaperlessBillingPopup.scss";
import React,{useState,useEffect,useRef} from "react";
import { getLocalizedStrings } from "./popupLocalizedStrings";
import { Link } from 'react-router';
 
function PaperlessBillingPopup(props){
  //const [checkOpen, setcheckOpen] = useState(false);
    let paper=getLocalizedStrings("PaperlessBilling");
    let language= drupalSettings.custom.currentLanguage.current_language;
    let learnMoreLink= "/"+language+"/helpcenter/topics/account-bills/how-do-i-sign-paperless-billing";
    
   return (
    <div>
     <div className={styles.popUp}>
     <div className={styles.popupContent+" "+styles.pbPopUpListSec}>
        {props.infoPopupTxt}
    </div>
     </div>
     </div>
);}
 
export default PaperlessBillingPopup;
